"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _util = require("../../Select/shared/util");
var _Checkbox = _interopRequireDefault(require("../../Checkbox"));
var _GroupLabel = _interopRequireDefault(require("./GroupLabel"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    label: {
      marginLeft: 8,
      width: '100%'
    },
    matchedText: {
      fontWeight: 'bold'
    },
    option: {
      '&:hover': {
        background: theme.palette.opacity.black[8]
      },
      background: function background(_ref) {
        var isSelected = _ref.isSelected;
        return isSelected ? theme.palette.opacity.primary[800][8] : theme.palette.white;
      },
      boxSizing: 'content-box',
      // MaterialUI v4 fix
      color: theme.palette.text.primary,
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '20px',
      paddingBottom: 11,
      // MaterialUI V4 fix
      paddingLeft: function paddingLeft(_ref2) {
        var isChildOption = _ref2.isChildOption;
        return isChildOption ? theme.spacing(2) : null;
      },
      paddingTop: 11,
      // MaterialUI V4 fix
      scrollBehavior: 'smooth'
    },
    standardText: {
      fontWeight: 400
    }
  };
});
var Option = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var focus = props.focus,
    groupLabel = props.groupLabel,
    isChildOption = props.isChildOption,
    indeterminate = props.indeterminate,
    index = props.index,
    isSelected = props.isSelected,
    isDisabled = props.isDisabled,
    searchInputValue = props.searchInputValue,
    onChange = props.onChange,
    value = props.value,
    label = props.label;
  var classes = useStyles({
    indeterminate: indeterminate,
    isChildOption: isChildOption,
    isDisabled: isDisabled,
    isSelected: isSelected
  });
  var menuRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (focus && !isDisabled && menuRef) {
      var _menuRef$current;
      // Move element into view when it is focused
      menuRef === null || menuRef === void 0 ? void 0 : (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.focus();
    }
  }, [focus, menuRef, isDisabled]);
  if (groupLabel) {
    return /*#__PURE__*/_react["default"].createElement(_GroupLabel["default"], {
      ref: ref,
      value: value
    }, label);
  }
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    classes: {
      root: classes.option
    },
    component: "div",
    disabled: isDisabled,
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
    classes: {
      root: classes.label
    },
    ref: menuRef,
    control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      indeterminate: indeterminate,
      onChange: onChange,
      tabIndex: index !== 0 ? '-1' : null,
      checked: isSelected,
      label: label,
      value: value
    }),
    label: (0, _util.getHighlightedText)(label, searchInputValue, classes)
  }));
});
Option.propTypes = process.env.NODE_ENV !== "production" ? {
  focus: _propTypes["default"].bool,
  groupLabel: _propTypes["default"].bool,
  indeterminate: _propTypes["default"].bool,
  index: _propTypes["default"].number,
  isChildOption: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  isSelected: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  searchInputValue: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
var _default = Option;
exports["default"] = _default;